import { ComplexValue } from 'app/types-shared';

export const sortByDescriptionAscending = (items: ComplexValue<number>[]): ComplexValue<number>[] =>
  [...items ?? []]?.sort((a, b) => a.description?.localeCompare(b.description, navigator?.language));
